module.exports = __webpack_public_path__ + "img/empty-list.b0733c66.jpg";